module.exports = __webpack_public_path__ + "img/Invasion-PRCA_10X_ACC.a8cc49c5.png";